import { Component, Inject, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-home-welcome-new-employee-popup',
  templateUrl: './home-welcome-new-employee-popup.component.html',
  styleUrls: ['./home-welcome-new-employee-popup.component.scss'],
})
export class HomeWelcomeNewEmployeePopupComponent  implements OnInit {
  buttonColorName:any;
  emailContentBody:any = ` Dear Employee name, <br /><br />I hope this message finds you well. <br /><br /> I wanted to take a moment to extend my warmest wishes to you on [specific occasion or reason, e.g., your work anniversary, your recent promotion, your birthday]. It’s a pleasure to work with someone as dedicated and talented as you, and I wanted to let you know how much your contributions are valued. <br /><br /> [Include any additional personal note or well-wishing relevant to the occasion.] <br /><br /> Wishing you continued success and happiness. Best regards,  <br /><br /> [Your Full Name]  <br />[Your Designation]`
  employeeName:any;
  employeeEmail:any;
  employeeContactNo:any
  isHideEmployeeInfo:any;


  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '300px',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter Email here...',
      defaultParagraphSeparator: '',
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { 
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    if (this.data != null) {
      this.employeeName = this.data.name;
      this.employeeEmail = this.data.officialEmail;
      this.employeeContactNo = this.data.contactNo;
      this.isHideEmployeeInfo = true;
    } else {
      this.isHideEmployeeInfo = false;
    }
  }

}
